import { devMode } from "../debug";

const DEFAULT_CONFIG_ENDPOINT =
  "/scel/uber_oauth/.well-known/openid-configuration";

const DEFAULT_OIDC_CONFIG = {
  issuer: "/scel/uber_oauth/",
  authorization_endpoint: "/scel/uber_oauth/authorize",
  token_endpoint: "/scel/uber_oauth/token",
  jwks_uri: "/scel/uber_oauth/jwks-configuration/certs",
  revocation_endpoint: "/scel/uber_oauth/revoke",
  response_types_supported: ["code"],
  subject_types_supported: ["public"],
  id_token_signing_alg_values_supported: ["RS256"],
};

type OIDCConfig = typeof DEFAULT_OIDC_CONFIG;

const CONFIGS = new Map<string, Promise<OIDCConfig>>();

async function loadConfig(endpoint: string): Promise<OIDCConfig> {
  try {
    const request = await fetch(endpoint);
    return (await request.json()) as OIDCConfig;
  } catch (e) {
    if (devMode) {
      console.error("Unable to load OIDC config, using default", e);
    }
    return DEFAULT_OIDC_CONFIG;
  }
}

export function getConfig(endpoint?: string): Promise<OIDCConfig> {
  endpoint = endpoint || DEFAULT_CONFIG_ENDPOINT;
  if (!CONFIGS.has(endpoint)) {
    CONFIGS.set(endpoint, loadConfig(endpoint));
  }

  return CONFIGS.get(endpoint)!;
}

const CLIENT_DEV = "40367803-4279-4302-ae22-a8fcc7bc4667";
const CLIENT_VEGA = "5f47ca99-afb7-41d6-bd63-37fc54442bd4";
const CLIENT_PREPROD = "94ad195c-514e-4603-a7cb-628265842710";
const CLIENT_PROD = "76f86bef-4d97-452d-86fc-9e13c7813fbe";

export function getClientId() {
  if (/\b(vega|test2)\b/.test(window.origin)) {
    return CLIENT_VEGA;
  }
  if (/\b(test|dev)\d?\b/.test(window.origin)) {
    return CLIENT_DEV;
  }
  if (/\bstaging\b/.test(window.origin)) {
    return CLIENT_PREPROD;
  }

  return CLIENT_PROD;
}
